export default function truncate(string, limit = 120) {
  if (string.length > limit) {
    return string.substr(0, limit).trim() + '...';
  }

  return string;
}
